<app-dialog-sidebar>
    <div class="notify-me-dialog">
        <header class="header">
            <h2 class="no-margin-bottom display-3">{{ 'notifyMe.headings.headline' | translateSafe }}</h2>
            <p>{{ 'notifyMe.description.about' | translateSafe }}</p>
        </header>

        @if (data.product; as product) {
            <div class="product-information content-size--normal">
                <h3 class="display-5">{{ 'notifyMe.headings.chosenProduct' | translateSafe }}</h3>
                <div class="card">
                    <div class="image-wrapper">
                        <app-product-image
                            [image]="{ src: product.imageUrl, name: product.productName }"
                            [width]="80"
                            [height]="80"
                            wrapperWidth="80px"
                            wrapperHeight="80px"
                            preset="94|94"
                            preset2x="150|150"
                        ></app-product-image>
                    </div>
                    <div class="description">
                        @if (product?.brand) {
                            <p class="detail">{{ product?.brand?.text }}</p>
                        }
                        <h5 class="product-name display-5">
                            {{ product.productName }}
                        </h5>
                    </div>
                </div>
            </div>
        }

        <form class="form-content content-size--normal" [formGroup]="form" appHandleInvalidOnSubmit
              (ngSubmit)="onSubmit()">
            <h3 class="display-5">{{ 'notifyMe.headings.yourInformation' | translateSafe }}</h3>
            <div class="form-group">
                <div class="inputs">
                    <app-input-email
                        [control]="form.controls.customerEmail"
                        [label]="'forms.labels.email' | translateSafe"
                        [placeholder]="'forms.placeholders.email' | translateSafe"
                        marginBottom="small"
                    >
                    </app-input-email>
                    <app-input
                        [control]="form.controls.customerName"
                        [label]="'forms.labels.fullName' | translateSafe"
                        [placeholder]="'forms.placeholders.fullName' | translateSafe"
                        [maxlength]="50"
                        [autocomplete]="'name'"
                        marginBottom="small"
                    ></app-input>
                </div>

                @if ((settingsService.settings$ | async)?.ecommerceSettings; as settings) {
                    <app-checkbox [control]="form.controls.customerConsent" marginBottom="small">
                            <span
                                class="kk-rte"
                                appInterceptLinks
                                [innerHTML]="settings.reservationConsentCheckbox | safe: 'html'"
                            ></span>
                    </app-checkbox>
                }
            </div>

            <div class="buttons">
                <button type="submit" class="kk-btn" [disabled]="(form.statusChanges | async) === 'INVALID'">
                    @if (state() === 'loading') {
                        <app-loading-dots class="spinner"></app-loading-dots>
                    } @else {
                        {{ 'notifyMe.buttons.notifyMe' | translateSafe }}
                    }
                </button>

                <button type="button" class="kk-btn kk-btn_secondary" (click)="onDoneOrCancel()">
                    {{ 'general.action.cancel' | translateSafe }}
                </button>
            </div>
        </form>
    </div>
</app-dialog-sidebar>
